module.exports = __webpack_public_path__ + "static/media/na-mx5-small-v3.2f9f9960.jpg";